import { render, staticRenderFns } from "./ViewPolygon.vue?vue&type=template&id=99e33f54"
import script from "./ViewPolygon.vue?vue&type=script&lang=js"
export * from "./ViewPolygon.vue?vue&type=script&lang=js"
import style0 from "./ViewPolygon.vue?vue&type=style&index=0&id=99e33f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports